import { WidgetDateFilter, WidgetSize, WidgetType } from 'containers/Widgets/types'

export type WidgetRoutes =
  | 'ops:route:average_distance'
  | 'ops:route:average_time_spent_per_route'
  | 'ops:route:average_fuel_consumption_per_route'
  | 'ops:route:route_status'
  | 'ops:task:total_tasks'
  | 'ops:task:task_status'
  | 'ops:service_point:top_ranked_sp_created_task'
  | 'ops:service_point:top_ranked_sp_visited_task'
  | 'engagement:order:total_orders_created'
  | 'engagement:order:top_ranked_order_items_created'
  | 'engagement:order:top_ranked_order_items_highest_price'
  | 'mrf:parcel:total_parcels_created'
  | 'mrf:parcel:parcel_status'
  | 'mrf:inbound:total_inbounds_created'
  | 'mrf:inbound:inbound_status'
  | 'mrf:process:average_time_spent_per_process'
  | 'mrf:process:top_ranked_output_process_materials'
  | 'mrf:process:top_ranked_input_process_materials'
  | 'mrf:outbound:total_outbounds_created'
  | 'mrf:outbound:outbound_status'

export type StaticWidgetLayoutItem = {
  type: WidgetType
  size: WidgetSize
  widgetId: WidgetRoutes
  currentFilter: WidgetDateFilter
}

export type StaticWidgetLayout = Array<StaticWidgetLayoutItem>

export const opsLayout: Array<Omit<StaticWidgetLayoutItem, 'currentFilter'>> = [
  {
    type: 'info',
    size: '1x2',
    widgetId: 'ops:route:average_distance',
  },
  {
    type: 'info',
    size: '1x1',
    widgetId: 'ops:route:average_fuel_consumption_per_route',
  },
  {
    type: 'rank',
    size: '2x2',
    widgetId: 'ops:service_point:top_ranked_sp_visited_task',
  },
  {
    type: 'info',
    size: '1x1',
    widgetId: 'ops:task:total_tasks',
  },
  {
    type: 'part-to-whole',
    size: '1x2',
    widgetId: 'ops:task:task_status',
  },
  {
    type: 'info',
    size: '1x2',
    widgetId: 'ops:route:average_time_spent_per_route',
  },
  {
    type: 'part-to-whole',
    size: '1x1',
    widgetId: 'ops:route:route_status',
  },
  {
    type: 'rank',
    size: '1x2',
    widgetId: 'ops:service_point:top_ranked_sp_created_task',
  },
]
export const MRFLayout: Array<Omit<StaticWidgetLayoutItem, 'currentFilter'>> = [
  {
    type: 'info',
    size: '2x2',
    widgetId: 'mrf:inbound:total_inbounds_created',
  },
  {
    type: 'info',
    size: '1x1',
    widgetId: 'mrf:outbound:total_outbounds_created',
  },
  {
    type: 'part-to-whole',
    size: '1x2',
    widgetId: 'mrf:inbound:inbound_status',
  },
  {
    type: 'info',
    size: '1x2',
    widgetId: 'mrf:parcel:total_parcels_created',
  },
  {
    type: 'info',
    size: '1x1',
    widgetId: 'mrf:process:average_time_spent_per_process',
  },
  {
    type: 'part-to-whole',
    size: '1x2',
    widgetId: 'mrf:parcel:parcel_status',
  },
  {
    type: 'part-to-whole',
    size: '1x1',
    widgetId: 'mrf:outbound:outbound_status',
  },
  // {
  //   type: 'rank',
  //   size: '2x2',
  //   widgetId: 'mrf:process:top_ranked_input_process_materials',
  // },
  // {
  //   type: 'rank',
  //   size: '2x2',
  //   widgetId: 'mrf:process:top_ranked_output_process_materials',
  // },
]

export const opsMRFLayout: Array<Omit<StaticWidgetLayoutItem, 'currentFilter'>> = [
  ...MRFLayout,
  ...opsLayout,
]

export const engLayout: Array<Omit<StaticWidgetLayoutItem, 'currentFilter'>> = [
  // {
  //   type: 'rank',
  //   size: '2x2',
  //   widgetId: 'engagement:order:top_ranked_order_items_created',
  // },
  // {
  //   type: 'rank',
  //   size: '2x2',
  //   widgetId: 'engagement:order:top_ranked_order_items_highest_price',
  // },
  {
    type: 'info',
    size: '1x2',
    widgetId: 'engagement:order:total_orders_created',
  },
]
